import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "@constants/cookies";
import cookieConsentSlice from "@slices/cookieConsent.slice";
import { RootState } from "@store/index";
import { getCookie } from "@utils/common.utils";

import CookieConsentBanner from "../CookieConsentBanner/CookieConsentBanner";
import CookieConsentIcon from "../CookieConsentIcon/CookieConsentIcon";

const CookieConsentManager = () => {
  const dispatch = useDispatch();
  const { consent, isBannerExpanded } = useSelector(
    (state: RootState) => state.cookieConsent
  );
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldRender(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (!shouldRender) return;

    const storedCookie = getCookie(COOKIE_CONSENT_KEY);

    if (!storedCookie) {
      dispatch(
        cookieConsentSlice.actions.setConsent(COOKIE_CONSENT_VALUES.NONE)
      );
      dispatch(cookieConsentSlice.actions.setBannerExpanded(true));
    } else {
      dispatch(cookieConsentSlice.actions.setConsent(storedCookie));
      dispatch(
        cookieConsentSlice.actions.setBannerExpanded(
          storedCookie === COOKIE_CONSENT_VALUES.NONE
        )
      );
    }
  }, [dispatch, shouldRender]);

  const handleBannerExpand = () => {
    dispatch(cookieConsentSlice.actions.setBannerExpanded(!isBannerExpanded));
  };

  const handleBannerClose = () => {
    dispatch(cookieConsentSlice.actions.setBannerExpanded(false));
  };
  return (
    <>
      {shouldRender && (
        <CookieConsentBanner
          currentConsent={consent}
          onClose={handleBannerClose}
          isBannerExpanded={isBannerExpanded}
        />
      )}

      <CookieConsentIcon onExpand={handleBannerExpand} />
    </>
  );
};

export default CookieConsentManager;
